module.exports = __webpack_public_path__ + "img/graytable.d37c8064.webp";